<template>
	<div class="go-to-add-on-app-content width-100 height-100 display-flex flex-wrap">
		<div class="flex-col-12">
			<h2 class="med">Go to {{ appName }} to continue</h2>
			<h3 class="reg">Follow the instruction on screen to create the feature (make sure you're logged in to the right account)</h3>
		</div>
		<div class="flex-1 flex-center--end flex-wrap">
			<div class="flex-col-4">
				<PrimaryButton @click="goToApp" class="width-100">Go to {{ appName }}</PrimaryButton>
			</div>
		</div>
	</div>
</template>

<script>
import WizardActionsFromStepMixin from '../common/WizardActionsFromStepMixin';
export default {
	name: 'GoToAddOnAppContent',
	mixins: [WizardActionsFromStepMixin],
	props: {
		app: { type: Object },
		projectId: { type: Number },
		featureType: { type: String },
		placementId: { type: Number }, // might be placementVersionId, depends on ext version (determined in GoToAddOnAppContentDataProvider)
		contextId: { type: Number },
		credentialsId: { type: Number },
		serviceWorkspace: { type: Object },
		paramsMap: { type: Object },
		paramsMapLabels: { type: Object },
		startCreationProcessOnCreated: { type: Boolean },
		addOnUrl: { type: String },
		elementType: { type: String },
	},
	computed: {
		appName() {
			return this.app.service_name;
		},
		creationProcessMessage() {
			return {
				projectId: this.projectId,
				featureType: this.featureType,
				serviceId: this.app.id,
				placementId: this.placementId,
				contextId: this.contextId,
				credentialsId: this.credentialsId,
				serviceWorkspace: this.serviceWorkspace,
				paramsMap: this.paramsMap,
				paramsMapLabels: this.paramsMapLabels,
				elementType: this.elementType,
			};
		},
	},
	methods: {
		goToApp() {
			this.sendStartCreationProcessMessage(this.creationProcessMessage);
			window.open(this.addOnUrl, '_blank');
		},
		startCreationProcess() {
			this.sendStartCreationProcessMessage(this.creationProcessMessage);
			this.closeWizard();
		},
	},
	created() {
		this.startCreationProcessOnCreated && this.startCreationProcess();
	},
};
</script>

<style lang="scss" scoped>
@import '@/components/CreationWizard/assets/creation-wizard-vars.scss';
.go-to-add-on-app-content {
	h3 {
		color: $secondary-content-title-font-color;
	}
}
</style>
